// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/organizations/firstparty/v5/confirm_capital_deposit_bylaw.proto

/* eslint-disable */

/** Request for confirming capital deposit bylaw annex generation. */
export interface ApiConfirmCapitalDepositBylawRequest {
  /** Whether to merge the bylaw annex. */
  readonly mergeBylawAnnex?: boolean | null | undefined;
}

/** Response for confirming capital deposit bylaw. */
export interface ApiConfirmCapitalDepositBylawResponse {
  /** Whether to merge the bylaw annex. */
  readonly mergeBylawAnnex?: boolean | null | undefined;
}

export const ApiConfirmCapitalDepositBylawRequest: MessageFns<ApiConfirmCapitalDepositBylawRequest> = {
  fromJSON(object: any): ApiConfirmCapitalDepositBylawRequest {
    return { mergeBylawAnnex: isSet(object.mergeBylawAnnex) ? globalThis.Boolean(object.mergeBylawAnnex) : null };
  },

  toJSON(message: ApiConfirmCapitalDepositBylawRequest): unknown {
    const obj: any = {};
    if (message.mergeBylawAnnex !== undefined && message.mergeBylawAnnex !== null) {
      obj.mergeBylawAnnex = message.mergeBylawAnnex;
    }
    return obj;
  },
};

export const ApiConfirmCapitalDepositBylawResponse: MessageFns<ApiConfirmCapitalDepositBylawResponse> = {
  fromJSON(object: any): ApiConfirmCapitalDepositBylawResponse {
    return { mergeBylawAnnex: isSet(object.mergeBylawAnnex) ? globalThis.Boolean(object.mergeBylawAnnex) : null };
  },

  toJSON(message: ApiConfirmCapitalDepositBylawResponse): unknown {
    const obj: any = {};
    if (message.mergeBylawAnnex !== undefined && message.mergeBylawAnnex !== null) {
      obj.mergeBylawAnnex = message.mergeBylawAnnex;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
